import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';
import reportService from '@/services/common/report.service';

@Module({ namespaced: true, name: 'report', store, dynamic: true })
class ReportModule extends VuexModule {
  public reportData: any[] = [];
  public reportIndividualData: any | null = null;
  public reportCoachClientId: string | null = null;
  public reportCoachClientCompanyName: string | null = null;
  public reportCoachClientType: string | null = null;
  public reportSorting: 'created' | 'updated' | 'goalId' = 'created';

  @MutationAction({ mutate: ['reportCoachClientId'], rawError: true })
  async updateReportCoachClientId(reportCoachClientId: any) {
    return { reportCoachClientId: reportCoachClientId };
  }

  @MutationAction({ mutate: ['reportCoachClientCompanyName'], rawError: true })
  async updateReportCoachClientCompanyName(reportCoachClientCompanyName: any) {
    return { reportCoachClientCompanyName: reportCoachClientCompanyName };
  }

  @MutationAction({ mutate: ['reportCoachClientType'], rawError: true })
  async updateReportCoachClientType(reportCoachClientType: any) {
    return { reportCoachClientType: reportCoachClientType };
  }

  @MutationAction({ mutate: ['reportSorting'], rawError: true })
  async updateReportSorting(reportSorting: 'created' | 'updated' | 'goalId') {
    return { reportSorting: reportSorting };
  }

  @MutationAction({ mutate: ['reportData'], rawError: true })
  async loadReport(data?: {
    companyName?: string;
    fromDate?: string;
    toDate?: string;
    department?: string;
    tz?: string;
  }) {
    const reportData = (await reportService.loadReport(data)) as any[];
    return { reportData: reportData };
  }

  @MutationAction({ mutate: ['reportIndividualData'], rawError: true })
  async loadIndividualReport(data: {
    coachId?: string;
    fromDate?: string;
    toDate?: string;
    tz?: string;
  }) {
    const reportIndividualData = (await reportService.loadIndividuals(
      data
    )) as any;
    return { reportIndividualData: reportIndividualData };
  }
}

const reportModule = getModule(ReportModule);
export default reportModule;
